export enum Content {
  FC_WEB_CONTENT_MANAGER = 'FC_WEB_CONTENT_MANAGER',
  FC_SEARCH_CONFIG_MANAGER = 'FC_SEARCH_CONFIG_MANAGER'
}
